import { animate, style, transition, trigger } from '@angular/animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { CronogramaMonitoramento, EntregaProjeto } from '../../models/entregas-projeto.model';
import { EntregasProjetoService } from '../../services/entregas-projeto.service';
import { ClonarModalComponent } from '../clonar-modal/clonar-modal.component';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { StorageService } from 'src/app/shared/services/storage.service';
import { CronogramaService } from 'src/app/shared/services/cronograma.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-detalhe-entrega-projeto-list',
  templateUrl: './detalhe-entrega-projeto-list.component.html',
  styleUrls: ['./detalhe-entrega-projeto-list.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ]
})
export class DetalheEntregaProjetoListComponent extends BaseListComponent<EntregaProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  entregasList: EntregaProjeto[];
  cronogramaMonitoramento: CronogramaMonitoramento;
  baseline: EntregaProjeto[];
  entregasPesquisa: EntregaProjeto[];
  ordenacao: boolean;
  filters: any;
  form: FormGroup;
  simNaoList: any[] = [
    { id: "0", label: "Não" },
    { id: "1", label: "Sim" },
  ];
  permission: any;
  filterActive: boolean = false;
  dragAndDropActive: boolean = false;
  filterIssueId: string = '';
  today: Date = new Date();
  audit: any;

  @ViewChild("clonarModal") clonarModal: ClonarModalComponent;
  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(
    private myService: EntregasProjetoService,
    public activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
    private storage: StorageService,
    private cronogramaService: CronogramaService,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.audit = { cron_id: this.idProjeto };
      this.filterIssueId = 'filterIssueValue_' + this.idProjeto;
      let filterValue = this.storage.getFilterValue(this.filterIssueId);

      this.addSub(
        this.myService.getFilters().subscribe((res) => {
          this.filters = res;
          this.filters.analysis.push({ id: -1, label: 'Sem Análise' });
          if (filterValue) {
            this.filterActive = true;
            this.form.patchValue(filterValue);
          }
          this.initList(this.getDataCreate());
        })
      )
    });
    this.initForm();

    this.addSub(EventSharedService.get('loading').subscribe(() => {
      this.loading();
    }))
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initForm() {
    this.form = new FormGroup({
      prt_issue_irfe_enabled_id: new FormControl(null),
      prt_issue_ircp_enabled_id: new FormControl(null),
      prt_issue_pf_prt_analysis_stat_id: new FormControl(null),
    });
  }

  initList(obj = null) {
    this.addSub(
      this.myService.getList(this.idProjeto, this.getDataCreate()).subscribe({
        next: (res) => {
          this.entregasList = res['list'];
          this.cronogramaMonitoramento = res['monitoring'];
          const newStatus = this.cronogramaService.generateStatusBaseline(res['monitoring'], res['baselinePercents']);
          this.entregasList = this.cronogramaService.generateAllStatus(this.entregasList);
          this.cronogramaMonitoramento['status'] = this.cronogramaService.statusBaseLine[newStatus];
          // console.log(res['baseline'])
          this.baseline = res['baseline']?.[0]?.['history'];
          this.entregasPesquisa = res['list'];
          this.permission = res['permission'];
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  drop(event: CdkDragDrop<string[]>) {
    this.ordenacao = true;
    moveItemInArray(this.entregasList, event.previousIndex, event.currentIndex);
    this.entregasList.forEach((item, index) => {
      item.code = index + 1;
    })
  }

  getDataCreateOrder(): any {
    return {
      pf_prt_issue_order: this.entregasList.map((item) => {
        return { id: item.id, code: item.code };
      })
    }
  }

  salvarOrdem() {
    this.loading();
    this.ordenacao = false;

    this.addSub(
      this.myService.salvarOrdem(this.getDataCreateOrder()).subscribe({
        next: (res) => {
          this.msgSuccess("Ordem Salva com Sucesso!");
          this.loaded();
        },
        error: (err) => {
          this.msgError(err?.error?.message);
          this.loaded();
        },
      })
    )
  }

  cleanSearch() {
    this.storage.removeFilterValue(this.filterIssueId);
    this.form.reset();
  }

  search() {
    this.loading();
    if (!Object.values(this.getDataCreate()).every(value => value === null)) {
      this.storage.setFilterValue(this.filterIssueId, this.getDataCreate());
    } else {
      this.storage.removeFilterValue(this.filterIssueId);
    }
    this.initList(this.getDataCreate());
  }

  clonarEntrega(id: number) {
    this.clonarModal.openModal(id, 'entregas');
  }

  viewResonsavel(entrega: EntregaProjeto) {
    this.modalResonsavel.openModal([entrega, ...entrega?.resp_adj]);
  }

  getDataCreate() {
    let data: any;
    data = Object.assign({}, data, this.form.value);
    // NECESSARIO VALIDAR STATUS, POIS QNDO PASSA ARRAY VAZIO QUEBRA PESQUISA
    if (!data?.prt_issue_pf_prt_analysis_stat_id?.length) {
      data.prt_issue_pf_prt_analysis_stat_id = null;
    }
    return data;
  }
  hasMilestoneInChild(item){
    var hasMile = item.end_is_milestone || item.start_is_milestone;
    if (hasMile){
      return true;
    }
    if(item?.pf_prt_issue_childs?.length > 0){
      return item.pf_prt_issue_childs.some(child => {
        return this.hasMilestoneInChild(child);
      }

      )
    }
    return false;
  }

  getStatus(status){
    return this.cronogramaService.statusList[this.cronogramaService.statusIdList[status] ?? 'STATUS_UNDEFINED'];
  }

  


  getProgress(item): number {
    try {
      if (item?.dt_start && item.dt_conclusion) {
        const today = new Date();
        const startDate = new Date(item.dt_start);
        const conclusionDate = new Date(item.dt_conclusion);
        const todayOnlyDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const startOnlyDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const conclusionOnlyDate = new Date(conclusionDate.getFullYear(), conclusionDate.getMonth(), conclusionDate.getDate());
        const duration = Math.ceil((conclusionOnlyDate.getTime() - startOnlyDate.getTime()) / (1000 * 60 * 60 * 24));
        const elapsed = Math.floor((todayOnlyDate.getTime() - startOnlyDate.getTime()) / (1000 * 60 * 60 * 24));

        if (duration <= 0) return 100;
        if (elapsed <= 0) return 0;

        const progress = (elapsed * 100) / duration;
        return progress > 100 ? 100 : progress;
      }

      return 0;
    } catch (e) {
      return 0;
    }
  }

  orderData(list){
    return list?.sort(function (a, b) {
      return +a.code - +b.code;
    }) ?? [];
  }

  getBaseline(task: EntregaProjeto, isProj = false){
    if(isProj){
      return this.baseline?.reduce((latest, current) => {
        return new Date(current.dt_foreseen_conclusion) > new Date(latest.dt_foreseen_conclusion)
          ? current
          : latest;
      });
    }
    return this.baseline?.find(b => b.id == task.id);
  }

  openIssue(id:number):void{
    this.loading();
    if (id) {
      this.router.navigate([id], { relativeTo: this.activatedRoute })
    } else {
      console.warn('ID não definido!');
    }
  }
  get linkGantt(){
    return environment.serverUrl + "/gantt/index.php?pf_id=" + this.idProjeto;
  }
  getRealValue(extra):number{
    var goal = extra?.goal ?? extra?.pf_prt_issue_extra?.goal;
    var value = (extra.done * 100) / (goal > 0 ? goal : 0.0001);
    return value;
  }
  formatoDecimal(extra): string {
    var decimal = extra?.pf_prt_issue_extra?.num_decimais ?? 0;
    return `1.${decimal}-${decimal}`;
  }
}
